import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { EnvUtils } from '@ecm/dispatcher';
import { Link, LinkService } from '@ecm/router';

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    public constructor(
        private readonly linkService: LinkService,
        @Inject(PLATFORM_ID) private readonly platformId: Record<string, unknown>,
    ) {}

    /**
     * Get current route url
     * @return {string}
     */
    public getCurrentUrl(): string {
        return isPlatformBrowser(this.platformId) ? window.location.href : '';
    }

    /**
     * check if link need to be disabled for "Eclair"
     * @return {boolean}
     */
    public isDisabledEclairLink(link: Link, params?: Map<string, string>): boolean {
        const computedLink = this.linkService.getLinkSync(link, params);
        return EnvUtils.isEclair() && (this.linkService.isBrowserLink(link) || computedLink === null);
    }
}
